import { get, writable } from 'svelte/store';
export const iframeStatus = writable(false);
export const createReportStore = () => {
    const reportStore = writable(null);
    const setActiveReport = (report) => reportStore.set(report);
    const setItemCounts = (itemCounts) => reportStore.update((reportState) => (Object.assign(Object.assign({}, reportState), { itemCounts })));
    const getState = () => get(reportStore);
    return {
        subscribe: reportStore.subscribe,
        getState,
        setActiveReport,
        setItemCounts,
    };
};
